import { Components, Theme } from "@mui/material";

export const MuiSlider: Components<Omit<Theme, "MuiSlider">>["MuiSlider"] = {
  styleOverrides: {
    root: ({ theme: { spacing } }) => ({
      padding: spacing(1),
    }),

    thumb: ({ theme: { palette } }) => ({
      backgroundColor: palette.common.black,
    }),

    rail: ({ theme: { palette } }) => ({
      backgroundColor: palette.grey[400],
    }),

    track: ({ theme: { palette } }) => ({
      backgroundColor: palette.common.black,
      border: 0,
    }),
  },
};
